define('common/ko/extension/smoothValue',[
    'jquery',
    'underscore',
    'knockout',
    'jquery.easing'
], function ($, _, ko) {
    ko.extenders.smooth = function(source, option) {

        var fractionalDigits = option.fractionalDigits || 0,
            targetSmoothValue = 0,
            doSmooth = option.if || function() { return true; };

        source.easingDuration = ko.observable(ko.unwrap(option.easingDuration) || 1500);
        source.easingMethod = ko.observable(ko.unwrap(option.easing) || 'easeOutQuint');

        function formatToSmoothValue(value) {
            if(!_.isNumber(value))
                value = parseFloat(value);
            return value.toFixed(fractionalDigits);
        }

        source.smoothValue = ko.observable(formatToSmoothValue(targetSmoothValue));

        var interval;
        var targetTime;
        var smoothValueDiff;
        var smoothValueStart;

        var updateSmoothValue = function() {
            if (!doSmooth(smoothValueDiff)) {
                window.cancelAnimationFrame(interval);
                interval = undefined;
                source.smoothValue(formatToSmoothValue(smoothValueStart + smoothValueDiff));
                return;
            }
            var timeDiff = targetTime - (new Date()).getTime();
            var easingDuration = source.easingDuration();
            var completeness = Math.min(1, (easingDuration - timeDiff) / easingDuration);
            if (completeness === 1) {
                window.cancelAnimationFrame(interval);
                interval = undefined;
            } else {
                window.requestAnimationFrame(updateSmoothValue);
            }
            completeness = $.easing[source.easingMethod()](0, completeness, 0, 1, 1);
            var newSmoothValue = smoothValueStart + (smoothValueDiff * completeness);
            source.smoothValue(formatToSmoothValue(newSmoothValue));
        };

        var runUpdater = function() {
            targetTime = (new Date()).getTime() + source.easingDuration();
            smoothValueStart = parseFloat(source.smoothValue());
            smoothValueDiff = parseFloat(source()) - smoothValueStart;

            if (_.isUndefined(interval)) {
                interval = window.requestAnimationFrame(updateSmoothValue);
            }
        };

        runUpdater(); //init initial value
        source.subscribe(function(newValue) {
            runUpdater();
        });

        return source;
    };
});

